var React = require('react');

function Pay4 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.112 24.647l-1.249-4.1h-6.279l-1.249 4.1h-3.935l6.079-17.295h4.465l6.102 17.295h-3.935zM16.991 17.484c-1.155-3.715-1.804-5.816-1.949-6.303s-0.25-0.872-0.312-1.155c-0.259 1.005-1.002 3.491-2.227 7.457h4.488zM31.859 24.647h-3.652v-14.184h-4.677v-3.039h13.006v3.039h-4.677v14.184zM46.479 24.647l-4.147-13.513h-0.106c0.149 2.749 0.224 4.583 0.224 5.501v8.011h-3.263v-17.223h4.971l4.076 13.171h0.070l4.324-13.171h4.972v17.224h-3.405v-8.152c0-0.385 0.006-0.829 0.018-1.331s0.065-1.838 0.159-4.006h-0.106l-4.442 13.489h-3.346z"}));
}

Pay4.defaultProps = {"version":"1.1","viewBox":"0 0 64 32"};

module.exports = Pay4;

Pay4.default = Pay4;
